var React = require('react');

function AudioPause (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},"svg.audio-pause.icon .no-fill { fill: none; }"),React.createElement("path",{"className":"primary-fill","d":"m50 2.5c-26.199 0-47.5 21.301-47.5 47.5s21.301 47.5 47.5 47.5 47.5-21.301 47.5-47.5-21.301-47.5-47.5-47.5zm-4 63.898c0 0.80078-0.60156 1.3984-1.3984 1.3984h-9.8008c-0.80078 0-1.3984-0.60156-1.3984-1.3984l-0.003906-32.797c0-0.80078 0.60156-1.3984 1.3984-1.3984h9.8008c0.80078 0 1.3984 0.60156 1.3984 1.3984zm20.602 0c0 0.80078-0.60156 1.3984-1.3984 1.3984h-9.8008c-0.80078 0-1.3984-0.60156-1.3984-1.3984l-0.003906-32.797c0-0.80078 0.60156-1.3984 1.3984-1.3984h9.8008c0.80078 0 1.3984 0.60156 1.3984 1.3984z","key":1})]);
}

AudioPause.defaultProps = {"className":"audio-pause icon","viewBox":"0 0 100 100"};

module.exports = AudioPause;

AudioPause.default = AudioPause;
